class LogMetrics {
    constructor() {
        this.logPosition = this.logPosition.bind(this);
    }

    logPosition(e) {
        e.preventDefault();

        if (typeof s !== 'undefined') {
            const pos = e.currentTarget.getAttribute('data-position');
            s.eVar38 = pos;
            s.prop38 = pos;
            try {
                s.t();
            }
            catch {
            }
        }

        const element = e.currentTarget;
        this.gtm(element, e).catch(() => {
            e.ctrlKey ? window.open(element.href, '_blank') : window.location.href = element.href;
        });
    };

    setOnClick() {
        var products = [];
        Array.prototype.forEach.call(document.querySelectorAll('a.itemImage'), function (el) {
            el.removeEventListener('click', this.logPosition);
            el.addEventListener('click', this.logPosition);
            products.push(this.getImpressionObj(el));
        }, this);
        this.gtmImpressions(products);
    }

    init() {
        var products = [];
        Array.prototype.forEach.call(document.querySelectorAll('a.itemImage'), function (el) {
            el.addEventListener('click', this.logPosition);
            products.push(this.getImpressionObj(el));
        }, this);
        this.gtmImpressions(products);
    }

    /**
     * formally the productClick event, now the new shiny GA4 select_item event
     * @param {Object} productObj An object representing a product.
     */
    async gtm(productObj, e) {
        if (typeof dataLayer !== 'undefined') {
            const code = document.getElementById('gtmCurrencyCode');
            dataLayer.push({ ecommerce: null });
            // Extract common event data
            const eventData = {
                'ecommerce': {
                    'currency': code ? code.value : 'USD',
                    'item_list_name': 'Search Results',
                    'items': [{
                        'item_id': productObj.getAttribute('data-alias'),
                        'item_name': productObj.getAttribute('data-name'),
                        'price': parseFloat(productObj.getAttribute('data-price')) || 0,
                        'item_brand': productObj.getAttribute('data-brand'),
                        'item_category': productObj.getAttribute('data-category'),
                        'index': parseInt(productObj.getAttribute('data-position')) || 0
                    }]
                }
            };

            // Push aos_select_item event (without callback)
            dataLayer.push({
                'event': 'aos_select_item',
                ...eventData
            });

            const trackingPromise = new Promise((resolve) => {
                // Push select_item event (with callback)
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    'event': 'select_item',
                    ...eventData,
                    'eventCallback': () => {
                        resolve(); // Just resolve, no need for a value
                    }
                });
            });

            const timeoutPromise = new Promise((resolve) => {
                setTimeout(() => resolve(), 1000); // Just resolve, no need for a value
            });

            // Wait for either callback or timeout, whichever comes first
            try {
                await Promise.race([trackingPromise, timeoutPromise]);
            } catch (_) {
                // proceed with navigation even if tracking fails
            }
        }

        // Navigate after tracking completes, times out, or errors
        e.ctrlKey ? window.open(productObj.href, '_blank') : window.location.href = productObj.href;
    }

    getImpressionObj(element) {
        return {
            'item_id': element.getAttribute('data-alias'),
            'item_name': element.getAttribute('data-name'),
            'price': parseFloat(element.getAttribute('data-price')) || 0,
            'item_brand': element.getAttribute('data-brand'),
            'item_category': element.getAttribute('data-category'),
            'item_list_name': 'Search Results',
            'index': parseInt(element.getAttribute('data-position')) || 0
        };
    }

    gtmImpressions(products) {
        if (products.length && typeof dataLayer !== 'undefined') {
            const code = document.getElementById('gtmCurrencyCode');
            // Split large product arrays into batches to avoid payload size issues
            const maxProductsPerBatch = 50;

            if (products.length > maxProductsPerBatch) {
                for (let i = 0; i < products.length; i += maxProductsPerBatch) {
                    const batch = products.slice(i, i + maxProductsPerBatch);

                    const eventData = {
                        'ecommerce': {
                            'currency': code ? code.value : 'USD',
                            'item_list_name': 'Search Results',
                            'items': batch
                        }
                    };

                    try {
                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            'event': 'aos_view_item_list',
                            ...eventData
                        });
                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            'event': 'view_item_list',
                            ...eventData
                        });
                    } catch (error) {
                        console.error('GTM Error in gtmImpressions batch:', error);
                        // Fallback: Only send standard GA4 event if custom fails
                        try {
                            dataLayer.push({ ecommerce: null });
                            dataLayer.push({
                                'event': 'view_item_list',
                                ...eventData
                            });
                        } catch (fallbackError) {
                            console.error('GTM Fallback also failed:', fallbackError);
                        }
                    }
                }
            } else {
                // Smaller number of products to send, no need to batch - AJS
                const eventData = {
                    'ecommerce': {
                        'currency': code ? code.value : 'USD',
                        'item_list_name': 'Search Results',
                        'items': products
                    }
                };

                try {
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        'event': 'aos_view_item_list',
                        ...eventData
                    });
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        'event': 'view_item_list',
                        ...eventData
                    });
                } catch (error) {
                    // Fallback: Only send standard GA4 event if custom fails
                    try {
                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            'event': 'view_item_list',
                            ...eventData
                        });
                    } catch (fallbackError) {
                        console.error('GTM Fallback also failed:', fallbackError);
                    }
                }
            }
        }
    };
}

export default new LogMetrics();